<template>
	<div>

		<egranty-input-field-popup
			:defaultValue="active[0].name"
			:is-open.sync="renamePopupVisible"
			label="Nowa nazwa"
			title="Zmień nazwę obszaru"
			for="area-tab-new-name"
			id="area-tab-new-name"
			long
			@save="rename"
		></egranty-input-field-popup>

		<v-toolbar color="blue">
			<v-toolbar-title>Obszar ({{ active[0].name }})</v-toolbar-title>
		</v-toolbar>

		<v-container style="padding: 12px;">
			<div>
				<v-btn @click="copyArea(active[0])"> Kopiuj obszar</v-btn>
			</div>

			<div>
				<v-btn
					color="lightred"
					v-if="!disabled"
					@click="deleteArea(active[0].id)"> Usuń
				</v-btn>
				<v-btn @click="putHigher">
					<v-icon color="white">arrow_upward</v-icon>
				</v-btn>
				<v-btn @click="putLower">
					<v-icon color="white">arrow_downward</v-icon>
				</v-btn>
				<v-btn @click="renamePopupVisible= true"> Zmień nazwę</v-btn>
			</div>
		</v-container>

	</div>
</template>
<script>
	import {Task} from "../../../../api/generated/Task";
	import EgrantyInputFieldPopup from "../../../../genericComponents/EgrantyInputFieldPopup";

	export default {
		name: "AreaTab",
		components: {EgrantyInputFieldPopup},
		methods: {

			getContestId() {
				return this.$route.params.id;
			},

			deleteArea(id) {
				Task.deleteArea(
					this,
					id, () => {
						this.$emit("refresh");
					}, errorResponse => {
						if (errorResponse.status === "NOT_ACCEPTABLE") {
							this.$emit("removalError", errorResponse);
						}
					});
			},

			putHigher() {
				Task.postAreaHigherInView(
					this,
					this.active[0].id,
					() => this.$emit("refresh"),
				);
			},

			putLower() {
				Task.postAreaLowerInView(
					this,
					this.active[0].id,
					() => this.$emit("refresh"),
				);
			},


			rename(newName) {
				Task.postRenameArea(
					this,
					this.active[0].id,
					newName,
					() => {
						this.$emit("refresh");
					});
			},
			copyArea(area){
				let copiedObject = {
					type: area.type,
					id: area.id,
					onlyChildNodes: false
				};
				this.$emit("copyObject",copiedObject);
			}

		},


		data() {
			return {
				extraData: {},
				renamePopupVisible: false,
			};
		},

		props: {
			active: {},
			disabled: {type: Boolean, default: false},
			copiedObject: {
				type: Object,
				default: function () {
					return {};
				},
			}
		},
	};
</script>
